import { Attr, BelongsTo, Model } from "spraypaint";

import SourceRecord from "shared/resources/SourceRecord";

import type Category from "./Category";
import type CopyrightAgency from "./CopyrightAgency";
import type Outlet from "./Outlet";

enum Frequency {
  "daily" = 0,
  "multiple_times_per_week" = 1,
  "weekly" = 2,
  "multiple_times_per_month" = 3,
  "monthly" = 4,
  "quarterly" = 5,
  "bimonthly" = 6,
  "yearly" = 7,
}

enum Origin {
  "mediatrack" = 0,
  "physical" = 1,
  "publisher" = 2,
  "cision" = 3,
}

@Model()
class Magazine extends SourceRecord {
  static jsonapiType = "magazines";

  @Attr() aliases: string[];

  @Attr() archivedAt: string;

  @Attr() audience: number;

  @BelongsTo() category: Category;

  @Attr() categoryId: number;

  @BelongsTo() copyrightAgency: CopyrightAgency;

  @Attr({ persist: false }) createdAt: string;

  @Attr() filenamePattern: string;

  @Attr() frequency: Frequency;

  @Attr() label: string;

  @Attr({ persist: false }) lastArticleAt: string;

  @Attr() locationId: number;

  @Attr({ persist: false }) medium: string;

  @Attr() notes: string;

  @Attr() origin: Origin;

  @BelongsTo() outlet: Outlet;

  @Attr() outletId: number;

  @Attr() relatedWebsiteId: number;

  @Attr() satirical: boolean;

  @BelongsTo() sourceGroup: SourceRecord;

  @Attr() sourceGroupId: number;

  @Attr() subscriptionExpiry: string;

  @Attr() tier: number;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() visible: boolean;
}

export default Magazine;
